/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Cta_DemoInputs */

const tr_landing_hero_cta_demo = /** @type {(inputs: Landing_Hero_Cta_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı Demoyu Deneyin`)
};

const en_landing_hero_cta_demo = /** @type {(inputs: Landing_Hero_Cta_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try the Live Demo`)
};

const de_landing_hero_cta_demo = /** @type {(inputs: Landing_Hero_Cta_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Demo testen`)
};

const ru_landing_hero_cta_demo = /** @type {(inputs: Landing_Hero_Cta_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробовать живое демо`)
};

/**
* | output |
* | --- |
* | "Try the Live Demo" |
*
* @param {Landing_Hero_Cta_DemoInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_hero_cta_demo = /** @type {((inputs?: Landing_Hero_Cta_DemoInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Cta_DemoInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_hero_cta_demo(inputs)
	if (locale === "de") return de_landing_hero_cta_demo(inputs)
	if (locale === "ru") return ru_landing_hero_cta_demo(inputs)
	return tr_landing_hero_cta_demo(inputs)
});